module.exports = __webpack_public_path__ + "static/img/sample-banner-pc.b52de59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/novel-coronavirus/sample-banner-pc.png
// module id = 5qEb
// module chunks = 1